import {
  AcknowledgeUserMessageMutationResponse,
  acknowledgeUserMessageMutation,
} from "@framework/cyclone/graphql/mutation";
import { makeRequest } from "@framework/cyclone/request";

export const acknowledgeUserMessage = async (
  id: string,
  communityID: string,
  serverURL: string,
  token?: string | null,
) => {
  if (!token) {
    return;
  }

  const url = new URL("/api", serverURL);
  const response = await makeRequest<AcknowledgeUserMessageMutationResponse>(
    url.toString(),
    acknowledgeUserMessageMutation,
    { id, communityID },
    token,
  );

  if (response.errors || !response.data) {
    return;
  }

  return response.data.acknowledgeUserMessage;
};
